var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isIntroduce ? `cont_introduce ${_vm.pageName}` : `cont_sub ${_vm.pageName}`,attrs:{"id":"kakaoContent"}},[_c('div',{attrs:{"id":"mArticle"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }